<template>
  <div class="p-story w-100 pb-4" id="p-story" v-if="story">
    <div class="h11 position-relative" id="p-story-1" style="top: -66px;"></div>
    <div class="b-title d-flex align-items-center">
      项目详情
    </div>
    <div>
      <div class="story-content bg-white p-body px-3 mb-3" v-html="story"></div>
      <div v-if="btns">
        <div v-if="isShow" class="stroy-open  justify-content-center align-items-center font-14"
             @click="open">
          <img class="mr-2 shou" src="/static/img/pro/kai.png" alt="">展开
        </div>
        <div v-if="!isShow" class=" stroy-close  justify-content-center align-items-center font-14"
             @click="close">
          <img class="mr-2 shou" src="/static/img/pro/shou.png" alt="">收起
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "advStory",
    data() {
      return {
        storyImg: '',
        isShow: true,
        btns: false,
      }
    },

    created() {

    },
    mounted() {

    },
    props: [
      'story'
    ],
    methods: {
      open() {
        $('.story-content').css('height', 'auto');
        this.isShow = false;
      },
      close() {
        $('.story-content').css('height', '9.25rem');
        this.isShow = true;
      },
    },
    watch: {
      story: function () {
        this.$nextTick(() => {
          let contentTag = $('.story-content').children().eq(0);
          let calcHeight = function () {
            let contentHeight = 200;
            let storyHeight = $('.story-content').height();
            if (storyHeight > contentHeight) {
              this.btns = true;
              $('.story-content').css('height', contentHeight);
              $('.stroy-open').show();
            } else {
              $('.story-content').css('height', storyHeight);
              $('.stroy-open').hide();
            }
          };
          calcHeight();
          // //特殊处理获取img的高度
          // if (contentTag[0].tagName === 'IMG') {
          //   document.querySelector('.story-content').firstChild.addEventListener('load', function () {
          //     calcHeight()
          //   })
          // } else {
          //   calcHeight()
          // }
        })
      }
    },
  }
</script>

<style>
  .p-story img {
    width: 100% !important;
    height: 100%;
    margin-left: 0 !important;
  }

  .story-content {
    overflow: hidden;
  }

  .story-content p {
    margin-bottom: 0;
  }
</style>
